global.I18n = I18n

export function setDefaultLocale() {
  const defaultLocale = $('html').data('default-lang')
  const currentLocale = $('html').attr('lang')

  I18n.defaultLocale = defaultLocale
  I18n.locale = currentLocale
}
